import { action } from 'easy-peasy';
import { IActionSetMoreAuditLogs } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreAuditLogs: IActionSetMoreAuditLogs = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  const newItems = mergeUniqueBy(state.items, payload, item => item.id);

  state.items = [...newItems];
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreAuditLogs;
